const getRolesFromPermissions = (userPermissions, appId = '*') => {
    const index = userPermissions && userPermissions.findIndex((perm) => perm.group === appId);
    return userPermissions && userPermissions[index] ? userPermissions[index].roles : [];
};
export default getRolesFromPermissions;
//# sourceMappingURL=getRolesFromPermissions.js.map